export default __webpack_public_path__ + "static/media/amyzhang.d43b2991.jpg";